import { useState, useEffect } from "react";

// Detect if the actual device is mobile/tablet (not just screen size)
function isMobileDevice(): boolean {
    if (typeof navigator === 'undefined') return false;
    return /Android|webOS|iPhone|iPad|iPod|Windows Phone|BlackBerry|Opera Mini|IEMobile/i.test(navigator.userAgent)
        || ('ontouchstart' in window && navigator.maxTouchPoints > 0);
}

// Detect if device is mobile using screen width as the primary signal
export const useDeviceType = () => {
    // Always start as "Desktop" for SSR consistency (matches server render)
    const [deviceType, setDeviceType] = useState("Desktop");
    useEffect(() => {
        const handleResize = () => {
            // Screen width is the primary signal — wide screens are always "Desktop"
            // even on touch devices like iPad Pro (1024px+)
            const detectedType = window.innerWidth < 768 ? "Mobile" : "Desktop";
            setDeviceType(detectedType);
        };
        // Detect correct device type immediately on mount
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    return deviceType;
};
